import { useEffect, useState } from "react";
import { useCollege } from "../context/CollegeContext";
import { useAuth } from "../context/AuthContext"; // Auth context for getting user ID
import { db } from "../firebase/firebaseConfig";
import { doc, setDoc, getDoc } from "firebase/firestore";

const colleges = ["MRU", "MRIIRS", "Echelon College"];

const CollegeSelector = () => {
  const { selectedCollege, setSelectedCollege } = useCollege();
  const { currentUser } = useAuth(); // Get the logged-in user
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) return;

    const fetchCollege = async () => {
      const userRef = doc(db, "users", currentUser.uid);
      const docSnap = await getDoc(userRef);

      if (docSnap.exists()) {
        setSelectedCollege(docSnap.data().college || ""); // Set from DB
      }
      setLoading(false);
    };

    fetchCollege();
  }, [currentUser, setSelectedCollege]);

  const handleCollegeChange = async (e) => {
    const selectedValue = e.target.value;
    setSelectedCollege(selectedValue);

    if (!currentUser) return;

    // Save selection in Firestore
    const userRef = doc(db, "users", currentUser.uid);
    await setDoc(userRef, { college: selectedValue }, { merge: true });
  };

  return (
    <div className="w-full max-w-xs">
      {loading ? (
        <p className="text-gray-500">Loading...</p>
      ) : (
        <select
          className="w-full px-4 py-3 text-lg font-medium rounded-lg shadow-lg border focus:outline-none focus:ring-2 transition-all 
          dark:bg-gray-800 dark:text-white dark:border-gray-600 focus:ring-indigo-500"
          value={selectedCollege}
          onChange={handleCollegeChange}
        >
          <option value="" disabled>
            Select College
          </option>
          {colleges.map((name) => (
            <option key={name} value={name}>
              {name}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};

export default CollegeSelector;
